import { StageActionBar } from "@components/campaigns/StageActionBar";
import type { Campaign } from "./context";

// Stage actions used to live in the WorkflowTab's StageActionBar, filtered to
// the active stepper stage (#2219 retires that stepper). They are re-homed into
// the DEFINE/RUN slot that owns each stage, using the canonical 10-stage
// numbering (see STAGE_NAMES): Brief 1, Blueprint 2, Market Map 3, Longlist 4,
// Outreach 5, Recruiter Assessment 6, Shortlist 7, Client Interviews 8,
// Offer 9, Post-Placement 10.

export function stageActionsFor(campaign: Campaign, stages: number[]) {
  return (campaign.stageActions ?? []).filter((action) => stages.includes(action.stage));
}

interface Props {
  campaign: Campaign;
  // The stage number(s) this slot owns; their configured actions surface here.
  stages: number[];
}

export function SlotStageActions({ campaign, stages }: Props) {
  const actions = stageActionsFor(campaign, stages);
  if (actions.length === 0) return null;
  return (
    <StageActionBar actions={actions} campaignId={campaign.id} campaignTitle={campaign.title} />
  );
}
